/*

Functions:

	$('ul').setMenuWidth('width', 0-1000, true/false);

	$('ul').addFirstLast();  // add class first and last

	$('div').showRandom('number_of_children_to_display', 'speed');

	array = $.shuffle(array); // shuffle array
	$('div').shuffle(); // shuffle childrens

	$('slider').pt_scroller({ duration:18000, easing:'linear'}); // scroles one way <slider><div> ... content .... </div></slider>


	More on the bottom
*/




(function($) {


	$.fn.setMenuWidth = function(my_width, similarity, apply_on_li){

		if(my_width == 'auto'){
			my_width = $(this).width();
		}

		var menu = $(this);
		var a = Object();
		var li = Object();
		var menu_width = 0;
		var li_padding = 0;
		similarity = typeof(similarity) != 'undefined' ? similarity : 0;
		apply_on_li = typeof(apply_on_li) != 'undefined' ? apply_on_li : false;


		menu.children().each( function(){
			if($(this).hasClass('begin') == false && $(this).hasClass('end') == false) {
				a = $(this).find('a:first');
				if(a.width() > 0){
					a.css('padding-left', '0px');
					a.css('padding-right', '0px');
					a.css('width', 'auto');
					menu_width += parseInt(a.outerWidth()) + parseInt(similarity);

					my_width -= parseInt($(this).css("margin-left").replace("px", "")) + parseInt($(this).css("margin-right").replace("px", ""));
				}
			}
		});

		var offset = 0;
		var efectve_width = 0;

		menu.children().each( function(){
			if($(this).hasClass('begin') == false && $(this).hasClass('end') == false) {
				a = $(this).find('a:first');
				try{
					li_padding = parseInt($(this).css("padding-left").replace("px", "")) + parseInt($(this).css("padding-right").replace("px", ""));
				}catch(err){ li_padding = 0; }

				offset = parseInt(a.css('border-right-width'))*1 + parseInt(a.css('border-left-width'))*1;
				a.css('width', (Math.round((my_width * ($(a).outerWidth() + parseInt(similarity)) ) / menu_width) - offset - li_padding) +'px');
				if(apply_on_li) { $(this).css('width', a.css('width') ); }
				a.css('display', 'block');
				a.css('padding-left', '0px');
				a.css('padding-right', '0px');
				$(this).addClass('modified');

				efectve_width += a.outerWidth(true);
			}
		});

		var correction = efectve_width - my_width;

		var last_a = Object;

		try {
			if( menu.children().filter("li.begin").length )
			{
				last_a = menu.children().filter("li:last").prev().find('a');
			}else{
				last_a = menu.children().filter(":last").find('a');
			}

			last_a.css('width', parseInt(last_a.css('width')) - correction);
		}catch(err){}

		return($(this));

	}

	$.fn.addFirstLast = function(element){
			if(typeof element == 'undefined'){ element=''; }
			$(this).each(function(){
				if( $(this).children(element+".begin").length ){
					$(this).children(element+":nth-child(2)").addClass("first");
					$(this).children(element+":last-child").prev().addClass("last");
				}else{
					$(this).children(element+":nth-child(1)").addClass("first");
					$(this).children(element+":last-child").addClass("last");
				}
			});
	}

	$.fn.styleSelect = function(){
			var cform_counter = 0;

			$(this).each(function(index) {

				// vars
				var do_selector = 'do_cform_' + cform_counter;
				var s_width = $(this).outerWidth() - 25;
				var s_height = $(this).outerHeight();
				var s_line_height = $(this).css('line-height');
				var s_text = $(this).find('option:selected').text();
				// warp
				$(this).wrap('<div class="cform_relative_div" />');

				// select
				$(this).addClass('cform_hide_object');
				$(this).bind('change', function(e){
						$('.'+do_selector).text( $(this).find('option:selected').text() );
				});

				// img
				var parent = $(this).parent();
				var img = 	$('<div/>', {
								'class' : 'cform_select_img',
								css : { width: s_width, height: s_height }
						 	});
				//span
				$('<span/>', {
				  	'class' : 'cform_slect_span ' + do_selector,
					text : s_text,
					css : { width: s_width, height: s_height }
				  }).appendTo(img);

				$(img).appendTo(parent);

				cform_counter++;

			});
	}


	$.fn.rowHover = function(){
			$(this).each(function(index) {
				$(this).bind('mouseover', function(){
					$(this).addClass('row_hover');
				});
				$(this).bind('mouseout', function(){
					$(this).removeClass('row_hover');
				});
			});
	}

	$.fn.rowHighlight = function(){
			$(this).each(function(index) {
				$(this).addClass('color_row');
			});
	}

	$.fn.tableColumnNumeration = function(){
		$(this).each(function(){
			$(this).find('tr').each(function(){
				var x = 1;
				$(this).children('td').each(function(){
					$(this).addClass('col_'+x);
					x++;
				});
			});
		});
	}

	$.fn.disableInput = function(){
			$(this).each(function(index) {
				$(this).attr('autocomplete', 'off');
			});
	}

	$.fn.resizeInputs = function(){
			$(this).each(function(index) {
				$(this).css('width', $(this).parent().width() );
			});
	}


	$.fn.inputTextDefaultValue = function(strText, class_to_parent){

			$(this).attr('title', strText);

			if($(this).val() == "" || $(this).val() == strText){ $(this).val( strText ); $(this).addClass('input_text_default_value'); $(this).trigger('change'); }
			if($(this).val() != ""){ $(this).trigger('change'); }

			$(this).bind('focusout', function(e){
				if($(this).val() == "" || $(this).val() == strText){ $(this).val( strText ); $(this).addClass('input_text_default_value'); $(this).trigger('change'); }
				else if($(this).val() != ""){ $(this).removeClass('input_text_default_value'); $(this).trigger('change'); }
				if(class_to_parent){ $(this).parent().removeClass('input_text_default_value_active'); }else{ $(this).removeClass('input_text_default_value_active'); }
			});
			$(this).bind('mouseup', function(e){
				if($(this).val() == strText){
					var $this = $(this);
					setTimeout(function(){ $this.select(); }, 10);
				}
			});
			$(this).bind('focusin', function(e){
				if($(this).val() == strText){
					var $this = $(this);
					$this.select();
				}
			});
			$(this).bind('keyup focus', function(e){
				if(e.keyCode != 9){
					if($(this).val() == "" || $(this).val() == strText){ $(this).val(''); $(this).removeClass('input_text_default_value'); }
					else if($(this).val() != ""){ $(this).removeClass('input_text_default_value'); }
					if(class_to_parent){ $(this).parent().addClass('input_text_default_value_active'); }else{ $(this).addClass('input_text_default_value_active'); }
				}
			});

	}
	$.fn.inputTextDefaultValueSubmitCheck = function(){
		$(this).bindFirst('submit',function(e){
			$(this).find('.input_text_default_value').each(function(e){
				if($(this).val() == $(this).attr('title')){
					$(this).val('');
				}
			});
			return true;
		});

	}

	$.fn.inputTextDefaultMoveErrorUp = function(){
		$(this).find('.field_error').each(function(e){
				$(this).parent().addClass('field_error');
			return true;
		});
	}

	$.fn.showRandom = function(number, speed){
		var randorder = new Array();
		var i;
		for (i = 0; i < $(this).children().size(); i++){
			randorder[i] = i;
		}
		randorder = $.shuffle(randorder);
		var i = 0;
		while(i < number){
			$(this).children().eq(randorder[i]).fadeIn(speed).css('display', 'block');
			i++;
		}
	}


	$.fn.shuffle = function() {
	  return this.each(function(){
		var items = $(this).children();
		return (items.length)
		  ? $(this).html($.shuffle(items))
		  : this;
	  });
	}

	$.shuffle = function(arr) {
	  for(
		var j, x, i = arr.length; i;
		j = parseInt(Math.random() * i),
		x = arr[--i], arr[i] = arr[j], arr[j] = x
	  );
	  return arr;
	}

	$.fn.reverse = [].reverse;

	$.fn.pt_scroller = function(arr){

		var slider = $(this);
		$(this).css({ 'position':'relative', 'overflow':'hidden' });
		var slider_w = $(this).outerWidth();

		var slide = $(this).children(':first');
		var slide_w = 0;

		$(slide).children().each(function(){
			slide_w += $(this).outerWidth(true);
		});

		$(slide).css({ 'float':'left', 'width':slide_w });

		var animated = jQuery('<div/>', {
			css: { 'position':'absolute', 'left':'0px', 'top':'0px', 'width':slide_w*2 }
		}).appendTo(slider);

		$(slide).clone().appendTo(animated);
		$(slide).appendTo(animated);


		$(animated).animate({	left:'-'+(animated.outerWidth()-slider_w)+'px' },
							{
								duration: arr.duration*2,
								easing: arr.easing,
								complete: function() {
									$(slider).pt_scroller_repeat(arr);
							}
						});

	}

	$.fn.pt_scroller_repeat = function(arr){

		var slider = $(this);
		var animated = $(this).children(':first');

		var slider_w = $(this).outerWidth();

		animated.css('left',	"-" + ((animated.outerWidth() / 2) - slider_w) + "px");
		$(animated).animate({	left:'-'+(animated.outerWidth()-slider_w)+'px' },
							{
								duration: arr.duration,
								easing: arr.easing,
								complete: function() {
									$(slider).pt_scroller_repeat(arr);
							}
						});
	}

	$.GetUrlID = function(tab_class){
		var strUrl = $(location).attr('href');
		var strUrlId = (strUrl.split("#")[1]);
		return strUrlId;
	}

	$.fn.pt_center_text = function(){
		var parent_height = 0;
		var my_height = 0;
		$(this).children().each(function(){
			objParent = $(this).parent().height();
			my_height = $(this).height();

			$(this).css('top', Math.round(((objParent * 0.5) - (my_height * 0.5)).toString()) + 'px');

		});
	}

	$.fn.pt_set_same_size = function(includeMargin){

		if(includeMargin !== true) includeMargin = false;
		var max_height = 0;

		$(this).each(function(){
			if($(this).height() > max_height){
				max_height = $(this).outerHeight(includeMargin);
			}
		});

		$(this).each(function(){
			var padding_margin = $(this).outerHeight(includeMargin) - $(this).height();
			$(this).css('height', max_height - padding_margin);
		});

	}

	$.fn.textShadowPrepare = function(inner_or_out,tag){
		this.each(function(){
			if(inner_or_out == 'inner'){
				$(this).wrapInner($('<'+tag+' />')).wrapInner($('<div />', { 'class': 'text_shadow' }));
			}else{
				$(this).wrap($('<div />', { 'class': 'text_shadow' }));
			}
		});
	}
	$.fn.textShadow = function(){
		$('.text_shadow').each(function(){
			var oryginal = $(this).children(':first');
			var shadow = oryginal.clone();
			var clear = $('<div />', { 'class': 'clear' });
			oryginal.after(clear);
			oryginal.after(shadow);
			oryginal.addClass('shadow');
		});

	}
	$.fn.bindFirst = function(name, fn) {
		this.bind(name, fn);

		if (typeof this.data('events') != 'undefined' && this.data('events') != null)
		{
			var handlers = this.data('events')[name.split('.')[0]];
			// take out the handler we just inserted from the end
			var handler = handlers.pop();
			// move it at the beginning
			handlers.splice(0, 0, handler);
		}
	};


	$.fn.initSlider = function() {

		var slides = $(this).find('.slde_item');

		if(slides.length > 1)
		{
			var menu = $('<div />', { 'class':'slde_nav' });
			slides.each(function(index, element)
			{
				var title = $(element).find('.slde_menu_item').html();
				$(element).find('.slde_menu_item').remove();
				menu.append( $('<a />', { 'class':'slde_nav_item', 'href':'#', 'id':'nav_'+index, 'text':title }) );
			});

			$(this).after(menu);
		}
		else
		{
			$(this).addClass('one_slide');
		}


	};

})(jQuery);


$(document).bind('before_ready',function(){

	/* Slider */
	$('.slde_slider').initSlider();
	/* Slider */


	$('.slde_nav').addFirstLast();
	$('.foot_menu ul').addFirstLast();
	$('.menu').addFirstLast();
	$('.top-menu ul').addFirstLast();

	$('.succ_slider').cycle({
		fx: 'scrollVert',
		speed: 500,
		pause: 1,
		timeout: 7000,
		delay: 500,
		random: 1,
		pager: '#location_nav ul',
		next:'.succ_next',
		prev:'.succ_prev',
		cleartypeNoBg:true
	});


	if ($(window).width() > 767) {
		$('.play_open').bind('click', function(){




		var playBox = $(this).parents('.play');
		var iframe = $(this).parent().find('.play_embed').clone();

		playBox.find('.play_dialog').dialog({
			  title: "Watch Video",
			  resizable: false,
			  width: 700,
			  height: 450,
			  position: ['center',60],
			  dialogClass:'js_website_dialog_container',
			  modal: true,
			  create: function(){
				  var iframeNew = iframe.clone();
				  iframeNew.find('iframe').attr('src', iframe.find('iframe').attr('src') + '&autoplay=1');
				  $(this).append(iframeNew);
			  },

			  close:function(){
				  $(this).dialog( "destroy" ).html('');
				  playBox.find('.play_border').append($(this));
			  }
			});

		});
	} else {
		$('.play_open').remove();
	}




});



$(document).ready(function(){



});

$(window).on('load', function(){
	/* Orga Slider */
	var w = 0;

	var orga_duration = 18000;

	if(typeof(document.orga_duration) != 'undefined')
		orga_duration = document.orga_duration;


});

function init_form(strSelector, arrCustonLang)
{
	var location = window.location.pathname.split('/');
	var page = location[location.length-1];

	if(
		page == 'index.html' ||
		page == 'about-us.html' ||
		page == 'contact-us.html' ||
		page == 'thank-you.html' ||
		page == 'ajax.html' ||
		page == ''
	)
		$(".user_interest_handle").val('General Inquiry');
	else
		$(".user_interest_handle").val($('title').text());








	$(strSelector+' .js_form_msg').hide();

	if($(strSelector+' .user_fname').val() != '' || $(strSelector+' .user_lname').val() != '')
	{
		$(strSelector+' .user_name').val( $(strSelector+' .user_fname').val() + ' ' + $(strSelector+' .user_lname').val() ).removeClass('input_text_default_value');
		if($(strSelector+' .user_name').val() == 'undefined undefined'){
			$(strSelector+' .user_name').val('');
		}
	}
	$(strSelector+' .js_form_submit').click(function(e){

		e.preventDefault();
		var full_name = $(strSelector+' .user_name').val();
		full_name = $.trim( full_name );
		var last_space = full_name.lastIndexOf(" ");
		var fname = full_name.substr(0, last_space);
		var lname = full_name.substr(last_space+1, full_name.length);
		if(fname.length > 0 && lname.length > 0){
			console.log('Inside True');
			$(strSelector+' .user_fname').val(fname);
			$(strSelector+' .user_lname').val(lname);
			$(this).parents("form").submit();
			//return true;
		}else{
			$(strSelector+' .user_name').parents('.form-group').addClass('has-error');

			if($(strSelector+" .js_contactus_form_quick_dialog").length < 1)
			{
				$(strSelector).append(
					$('<div/>',{'class': 'js_contactus_form_quick_dialog'})
				);
			}

			var msg_title = "Form Submit Message";
			if(window.language == 'sp') msg_title="Forma Enviar mensaje";
			var close_bt = "Close";
			if(window.language == 'sp') close_bt = "Cerrar";

			$(strSelector+' .js_contactus_form_quick_dialog:first').dialog({
				title: msg_title,
				resizable: false,
				minHeight: 100,
				height: 'auto',
				width: 450,
				modal: true,
				create: function(){

					var msg_text = "Please Enter Your First and Last Name.";
					if(window.language == 'sp') msg_text = "Introduzca su nombre y apellido.";
					$(this).html('<div class="form_error_main">'+msg_text+'<\/div>');
				},
				close:function(){
					$(".js_contactus_form_quick_dialog").dialog( "destroy" ).html('').remove();
					$(strSelector).append(
						$('<div/>',{'class': 'js_contactus_form_quick_dialog'})
					);

				},
				buttons:[
					{
						text: close_bt,
						click: function(e) {
							$(".js_contactus_form_quick_dialog").dialog( "destroy" ).html('').remove();
							$(strSelector).append(
								$('<div/>',{'class': 'js_contactus_form_quick_dialog'})
							);

						}
					}
				]
			});
		}
	});
}

function init_bs_form(strSelector) {

	$(strSelector+' form').submit(function(e){
		console.log('inside');
		e.preventDefault();
		var full_name = $(strSelector+' .user_name').val();
		full_name = $.trim( full_name );
		var last_space = full_name.lastIndexOf(" ");
		var fname = full_name.substr(0, last_space);
		var lname = full_name.substr(last_space+1, full_name.length);


		if(fname.length > 0 && lname.length > 0){

			$(strSelector+' .user_fname').val(fname);
			$(strSelector+' .user_lname').val(lname);
			$(this).unbind('submit');
			$(this).submit();
			//return true;


		}else{
			$(strSelector+' .user_name').closest('.form-group').addClass('has-error');

			var msg_text = "Please Enter Your First and Last Name.";


			$(strSelector+' .error-col').html('');
			$(strSelector+' .error-col').append(
				$(
					'<div/>',
					{
						'class': 'form_msg alert alert-danger',
						'text': msg_text
					}
				)
			);
		}
	});

}

waitForFinalEvent = (function () {
    var timers = {};
    return function (callback, ms, uniqueId) {
  	if (!uniqueId) {
  	  uniqueId = "Don't call this twice without a uniqueId";
  	}
  	if (timers[uniqueId]) {
  	  clearTimeout (timers[uniqueId]);
  	}
  	timers[uniqueId] = setTimeout(callback, ms);
    };
})();
